(function ($) {
	if ($(".hero__slider").length > 0) {
		const slider = new Splide('.hero__slider', {
			type: 'fade',
			perPage: 1,
			arrows: false,
			autoplay: true,
			pagination: false
		});
		slider.mount();
	}
})(jQuery);